export default class AddressSelectorViewModel {
    postcode: string = '';
    addressIndex: number | undefined = undefined;
    address1: string = '';
    address2: string = '';
    address3: string = '';
    address4: string = '';
    postcodeIn: string = '';
    postcodeOut: string = '';
}